<div class="advanced-search relative">
    <img  priority [ngSrc]="landscapeImage" class="absolute" fill >
    <div class="sm:text-4xl text-3xl">{{'easy_way_to_find_a' | translate}}</div>
    <div class="section-tabs">
        <button class="tab-item" [class.active]="activeTab == 0" (click)="changeTab(0)">{{'products' |
            translate}}</button>
        <button class="tab-item" [class.active]="activeTab == 1" (click)="changeTab(1)">{{'real_estate' |
            translate}}</button>

        <!--   <button class="tab-item" [class.active]="activeTab == 2" (click)="changeTab(2)">{{'services' |
            translate}}</button> -->
    </div>
    <div class="search-forms relative" #searchFrom>

        <div class="form-page" [class.active]="activeTab == 0">
            <form class="search-form" [formGroup]="productsForm">
                <div class="text-input" (click)="openForm(productsForm)">
                    <img src="assets/svg/sector/search_icon.svg" class="search-ic">
                    <input class="cursor-pointer" type="text" formControlName="searchText"
                        [placeholder]="('search_in' | translate) + ' ' + ('products' | translate)">
                </div>
                <button class="search-button" (click)="searchProducts()">{{'search' | translate}}</button>
            </form>
        </div>
        <div class="form-page" [class.active]="activeTab == 1" #firstTab>
            <form class="mobile:flex-col search-form" [formGroup]="realestateForm">
                <ng-container *ngFor="let property of searchInfo?.data">
                    <ng-container
                        *ngIf="property?.name.en == 'Property Type' || property?.name.en == 'Area' || property?.name.en == 'Type'">

                        <ng-container *ngIf="property?.type =='list'">
                            <app-select-input *ngIf="!property?.filterType || property?.filterType == 'list'"
                                borderRadius="0" [multiple]="property?.multipleSelect || false"
                                [control]="realestateForm?.get(property?.name.en)"
                                [label]="translateHelper.localize(property?.name)"
                                [customLabel]="translateHelper.localize(property?.filterLabel)"
                                [selectList]="property?.availableValues" appearance="legacy" floatLabel="always"
                                [placeholder]="('please_select'|translate) + ' ' + translateHelper.localize(property?.name)"></app-select-input>


                            <app-select-search *ngIf="property?.filterType == 'search'" borderRadius="0"
                                [multiple]="property?.multipleSelect || false"
                                [control]="realestateForm?.get(property?.name.en)"
                                [label]="translateHelper.localize(property?.name)"
                                [customLabel]="translateHelper.localize(property?.filterLabel)"
                                [selectList]="property?.availableValues" appearance="legacy" floatLabel="always"
                                [placeholder]="('please_select'|translate) + ' ' + translateHelper.localize(property?.name)"></app-select-search>
                            <div class="separator"></div>

                            <app-select-button *ngIf="property?.filterType == 'buttons'" borderRadius="0"
                                [multiple]="property?.multipleSelect || false"
                                [control]="realestateForm?.get(property?.name.en)"
                                [label]="translateHelper.localize(property?.name)"
                                [customLabel]="translateHelper.localize(property?.filterLabel)"
                                [selectList]="property?.availableValues"
                                [combineControl]="realestateForm?.controls['combinePropertyValue']"
                                [combineLabel]="translateHelper.localize(block.combineProperty?.name)"
                                [combineSelectList]="block.combineProperty?.availableValues" appearance="legacy"
                                floatLabel="always"
                                [placeholder]="('please_select'|translate) + ' ' + translateHelper.localize(property?.name)"></app-select-button>
                        </ng-container>
                        <ng-container *ngIf="property?.type =='checkbox'">
                            <div class="separator"></div>
                            <app-checkbox-input [control]="realestateForm?.get(property?.name.en)"
                                [label]="translateHelper.localize(property?.name)"></app-checkbox-input>
                        </ng-container>


                    </ng-container>
                </ng-container>
                <!--       <app-select-search borderRadius="0" [multiple]="true" [control]="realestateForm.get('area')"
                                [label]="'area' | translate" [selectList]="selectList" appearance="legacy"
                                floatLabel="always"></app-select-search>
                            <div class="separator"></div>
                            <app-select-input borderRadius="0" [multiple]="true" [control]="realestateForm.get('type')"
                                [label]="'property_type' | translate" [selectList]="selectList" appearance="legacy"
                                floatLabel="always"></app-select-input> -->
                <button class="search-button" (click)="searchRealestate()">{{'search' | translate}}</button>
            </form>
        </div>
        <!-- <div class="form-page" [class.active]="activeTab == 2">
            <form class="search-form" [formGroup]="servicesForm">
                <div class="text-input">
                    <img src="assets/svg/sector/search_icon.svg" class="search-ic">
                    <input type="text" formControlName="searchText"
                        [placeholder]="('search_in' | translate) + ' ' + ('services' | translate)">
                </div>
                <button class="search-button" (click)="searchServices()">{{'search' | translate}}</button>
            </form>
        </div> -->
        <div [class.active]="active && activeTab==0"
            class="results-box overflow-hidden flex flex-col text-custom-black absolute top-[62px] rtl:right-0 ltr:left-0 max-w-[600px] w-full max-h-[240px] bg-white rounded-e-2xl">
            <div class="result-container">
                <div class="flex flex-col" *ngIf="products.length > 0">
                    <ul class="suggestions__list">
                        <li *ngFor="let product of products" class="suggestions__item">
                            <div class="suggestions__item-info">
                                <a [routerLink]="((product.sector?.seo?.slug) ? ['/', translateService.currentLang,'sector', product.sector?.seo?.slug] : ['/']).concat([(product.layout && product.layout!='product')?product.layout:product.type || 'product', product.seo?.slug])"
                                    class="m-0 block suggestions__item-name font-semibold text-ellipsis overflow-hidden text-nowrap w-11/12 sm:w-9/12"
                                    [innerHTML]="translateHelper.localize(product.name)">

                                </a>
                            </div>
                            <div class="suggestions__item-price mobile:hidden"
                                *ngIf="!product.hidePrice && (product.price || product.taxedPrice)">
                                {{ product.taxedPrice || product.price|currencyConvert : product.companyData.currencyMeta.code }}
                            </div>
                        </li>
                        <li>
                            <div class="cursor-pointer hover:underline hover:bg-slate-100 flex flex-row justify-center p-[12px] text-base font-bold view-all"
                                (click)="search()">
                                View All {{total}} products <mat-icon class="ms-1 mat-icon-rtl-mirror"
                                    fontIcon="arrow_right_alt"></mat-icon>

                            </div>
                        </li>
                    </ul>
                </div>
                <div class="flex flex-col empty-state" *ngIf="products.length == 0">
                    <div class="text-center p-5">
                        <img src="assets/svg/search-empty-icon.svg">
                        <p class="mt-3">{{"Couldn't find items"|translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>